<template>
  <div>
    <a-spin :spinning="spinning" size="large">
      <div class="dynamic">
        <a-row type="flex" justify="space-between" style="margin-bottom:30px">
          <a-col>
            <h3>案情通告</h3>
          </a-col>
          <a-col>
            <a-button type="primary" icon="plus" @click="$refs.noticeModal.show({job_id: id})">案情通告</a-button>
          </a-col>
        </a-row>
        <template v-if="infoData.length > 0">
          <ul class="info-list">
            <li v-for="(list, i) in infoData" :key="i">
              <a-row type="flex" justify="space-between">
                <a-col>
                  <p>{{ list.updated_at }}</p>
                  <p v-html="list.content.replace(/\n/g, '<br>')"></p>
                </a-col>
                <a-col>
                  <a-button type="link" icon="edit" @click="$refs.noticeModal.show(list)">编辑</a-button>
                </a-col>
              </a-row>
            </li>
          </ul>
          <a-button type="primary" v-show="haveMoreInfo" @click="getInfoData">查看更多</a-button>
        </template>
        <a-empty v-else>
          <img src="~@/assets/original.png" alt slot="image" />
        </a-empty>
      </div>
    </a-spin>

    <notice-modal ref="noticeModal"></notice-modal>
  </div>
</template>

<script>
import Api from "@/api";
import NoticeModal from "./notice-modal";
export default {
  name: "postDynamic",
  props: {
    id: {
      default: -1
    }
  },
  data() {
    return {
      infoData: [],
      spinning: false,
      infoLoadMoreStatus: false,
      infoPage: 0,
      infoTotal: 0
    };
  },
  components: { NoticeModal },
  created() {
    this.getInfoData();
  },
  computed: {
    haveMoreInfo() {
      let more = this.infoTotal - this.infoPage * 10;
      return more > 0;
    }
  },
  methods: {
    getInfoData() {
      this.infoPage++;
      this.spinning = true;
      let params = {
        job_id: this.id,
        page: this.infoPage,
        limit: 10
      };
      if (this.infoPage > 1) {
        this.infoLoadMoreStatus = true;
      }
      Api.post
        .getNotice(params)
        .then(res => {
          this.infoTotal = +res.total;

          if (this.infoPage > 1) {
            this.infoData = this.infoData.concat(res.list);
          } else {
            this.infoData = res.list;
          }
        })
        .finally(() => {
          this.infoLoadMoreStatus = false;
          this.spinning = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.dynamic {
  text-align: center;
  padding: 25px 0;
  min-height: 400px;
  .top {
    display: flex;
    align-items: center;
    p {
      flex: 1;
    }
  }
  .title {
    text-align: left;
    font-weight: bold;
    font-size: 16px;
  }
  .btn {
    text-align: center;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .info-list {
    text-align: left;

    li {
      padding-bottom: 8px;
      p {
        color: #666;
        &:first-child {
          color: #999;
          margin-bottom: 6px;
        }
      }
    }
  }
  .dynamic-list {
    text-align: left;
    li {
      margin-bottom: 35px;
      p {
        margin-top: 5px;
      }
    }
    span {
      &.t1 {
        color: #333;
      }
      &.time {
        color: #999;
      }
      &.reason {
        color: #f6b502;
      }
    }
  }
}
</style>
